export default __webpack_public_path__ + "static/media/resume-folder.e6dbdc3d.svg";